export const ExportTypificationMessages: any = {
    TITLE: 'Exporte de tipificaciones',
    MESSAGE_OK: 'El exporte fue descargado exitosamente',
    MESSAGE_ERROR: 'Se presento un error al descargar el exporte',
};
